<template>
	<div>
		<video class="bg-video" src="/footage/madalyon.mp4" autoplay muted loop></video>
		<router-link :to="{name:'metin'}" class="page-nav-link" id="link-bottom"><img class="link-image" src="images/arrow-leftright-white-01.png" alt="" style="max-width: 95px; max-height: 95px;"></router-link>

	</div>
</template>

<script>
	export default {
		name: "MadalyonPage"
	}
</script>

<style scoped>
	.bg-video {
		top: 0;
		left: 0;
		position: absolute;
		object-fit: cover;
		width: 100%;
		height: 100%;
		z-index: -2;
	}

	.page-nav-link {
		position: absolute;
		top: 50%;
	}


</style>